var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreditRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 67,
    viewBox: "0 0 144 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    fillRule: "evenodd",
    stroke: "#f7f7f7",
    d: "M72.141.497L.5 120.502h143L72.141.497zm41.268 80.477H30.69l16.714-27.997h49.358l16.647 27.997zM93.387 47.301H50.792l21.34-35.745 21.255 35.745zM27.302 86.649h89.482l16.755 28.178H10.48l16.822-28.178z"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#f7f7f7",
    x: 62.5,
    y: 42.5,
    style: {
      fontFamily: "ubuntu",
      fontSize: 28
    }
  }, "A"), /*#__PURE__*/React.createElement("text", {
    fill: "#f7f7f7",
    x: 64.5,
    y: 76.5,
    style: {
      fontFamily: "ubuntu",
      fontSize: 28
    }
  }, "B"), /*#__PURE__*/React.createElement("text", {
    fill: "#f7f7f7",
    x: 64.5,
    y: 111.5,
    style: {
      fontFamily: "ubuntu",
      fontSize: 28
    }
  }, "C"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditRating);
export default __webpack_public_path__ + "static/media/creditRating.6cdb7ce709297ec3be7b757e240a4921.svg";
export { ForwardRef as ReactComponent };